import { AnyAaaaRecord } from "dns";
import { apiSlice } from "../store/app.api";
import { supabase } from "../utils/API";

type ReviewStatus = "ACKNOWLEDGED" | "DUPLICATE" | "REJECTED";

const deputyReviewAPI = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getDeputyReviews: build.query<any, any>({
      queryFn: async ({ year, start, end }) => {
        let { data, count, error } = await supabase
          .from("review_watched_movie")
          .select(
            `
        id,
        created_at,
        status,
        has_violation,
        ticket_request:ticket_requests (
          id,
          movie_title,
          cinema_name
        ),
        deputy:users!deputy_id (
          name,
          last_name,
          profile_picture,
          sub_role
        )
        `,
            { count: "exact" }
          )
          .gte("created_at", `${year}-01-01`)
          .lte("created_at", `${year}-12-31`)
          .in("status", ["PENDING", "ACKNOWLEDGED", "REJECTED", "DUPLICATE"])
          .order("created_at", { ascending: true })
          .range(start, end);
        if (error) throw error;

        // ✅ Return as a custom response
        return { data, count }; // Wrap the array and count in one object
      },
      providesTags: ["deputy_reviews"],
    }),
    getDateFilteredDeputyReviews: build.query<any, any>({
      queryFn: async ({ startDate, endDate }) => {
        console.log(startDate);
        let { data } = await supabase
          .from("review_watched_movie")
          .select(
            "id,created_at,status,ticket_request:ticket_requests(*,theatre_group:theatre_groups(name)),deputy:users!deputy_id(name,last_name,email,profile_picture),processed_by_user_id:users!processed_by_user_id(name,last_name,email,profile_picture),attachments:movie_report_attachments(*)"
          )
          .in("status", ["ACKNOWLEDGED"])
          .gte("created_at", startDate) // Filter for dates greater than or equal to startDate
          .lte("created_at", endDate)
          .order("created_at", { ascending: false });
        return { data };
      },
      providesTags: ["deputy_reviews"],
    }),
    getDeputyReviewDetails: build.query<any, any>({
      queryFn: async (id: number) => {
        let { data } = await supabase
          .from("review_watched_movie")
          .select(
            "*,ticket_request:ticket_requests(*,theatre_group:theatre_groups(*)),deputy:users!deputy_id(*),admin:users!processed_by_user_id(*),attachments:movie_report_attachments(*)"
          )
          .eq("id", id)
          .single();
        return { data };
      },
      providesTags: ["deputy_reviews"],
    }),

    updateDeputyReviewStatus: build.mutation<
      any,
      {
        id: number | string;
        status: ReviewStatus;
        user_id: string;
        admin_comment: string;
      }
    >({
      queryFn: async (params) => {
        const { data, error } = await supabase
          .from("review_watched_movie")
          .update({
            status: params.status,
            processed_by_user_id: params.user_id,
            admin_comment: params.admin_comment,
          })
          .eq("id", params.id)
          .single();
        if (error) return { error };
        return { data };
      },
      invalidatesTags: ["deputy_reviews"],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetDeputyReviewsQuery,
  useGetDeputyReviewDetailsQuery,
  useUpdateDeputyReviewStatusMutation,
  useGetDateFilteredDeputyReviewsQuery,
} = deputyReviewAPI;
